import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';
import css from '@styled-system/css';
import reactDom from 'react-dom';
import Avatar from 'react-avatar';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { formatTime } from 'utils/format-time';
import { BiTime } from 'react-icons/bi';
import { FaChevronLeft, FaTimes } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CustomLeftArrowNew } from 'components/carousel/left-arrow-new';
import { CustomRightArrowNew } from 'components/carousel/right-arrow-new';
import { Image } from 'components/Image';

const SeriesPlaylistModal = ({ isModalOpen, setIsModalOpen, tracks, seriesSlug }) => {
  const [seasonIndex, setSeasonIndex] = useState(0);
  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const options = {
    dots: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 3,
    initialSlide: 0,
    adaptiveHeight: true,
    touchMove: true,
    touchThreshold: 10,
    // center: false,
    loop: false,
    lazyLoad: true,
    nextArrow: <CustomRightArrowNew />,
    prevArrow: <CustomLeftArrowNew />,
    responsive: [
      {
        breakpoint: 4000,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };

  return reactDom.createPortal(
    isModalOpen && (
      <StyledModal>
        <Wrapper>
          <Heading onClick={onCloseModal}>
            <FaTimes size={25} />
          </Heading>
          <Details>
            <div className="seasons-container">
              {tracks.map((item, index) => (
                <button
                  type="button"
                  key={index}
                  className={`tab ${seasonIndex === index ? 'active' : ''} `}
                  onClick={(e) => {
                    setSeasonIndex(index);
                  }}>
                  SEASON {index + 1}
                </button>
              ))}
            </div>

            <div className="episode-details-container">
              <Slider {...options}>
                {tracks[seasonIndex]?.contents?.map((item, index) => (
                  <Link
                    className="single-episode"
                    key={index}
                    to={`/content/play/series/${seriesSlug}?season_index=${
                      seasonIndex + 1
                    }&episode_index=${index + 1}`}>
                    <div className="img-container">
                      {/* <img
                        src={`${process.env.REACT_APP_IMAGE_URL}400xauto/${item?.horizontalThumbnails[0]?.path}`}
                        alt="Episode Banner"
                      /> */}
                      <Image
                        type="series"
                        orientationType="horizotal"
                        className="main-image"
                        src={
                          window.innerWidth > 768
                            ? `${process.env.REACT_APP_IMAGE_URL}400xauto/${item?.horizontalThumbnails[0]?.path}`
                            : `${process.env.REACT_APP_IMAGE_URL}200xauto/${item?.horizontalThumbnails[0]?.path}`
                        }
                        alt={'Episode Banner'}
                        loading="lazy"
                      />
                    </div>

                    <div className="episodeInfo">
                      <div className="episodeDetails">
                        <div className="episodeTitle">{item?.title}</div>
                        <div className="episodeDuration">
                          <BiTime />
                          <span>{formatTime(item?.durationInSeconds)}</span>
                        </div>

                        <div className="episodeDesc">{item?.description}</div>
                      </div>
                    </div>
                  </Link>
                ))}
              </Slider>
            </div>
          </Details>
        </Wrapper>
      </StyledModal>
    ),
    document.getElementById('portal')
  );
};
const StyledModal = styled.div`
  position: fixed;
  top: 45vh;
  left: 0;
  // height: 100%;
  width: 100%;
  z-index: 99999999;
  // background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;

  .button-container {
    position: relative;
    top: -15px;
    .close-icon {
      font-size: 32px;
      cursor: pointer;
    }
  }

  @media (max-width: 1499px) {
    top: 30vh;
  }
  @media (max-width: 1024px) {
    top: 47vh;
  }
  @media (max-width: 820px) {
    top: 58vh;
  }

  @media (max-width: 639px) {
    top: 45vh;
  }
`;
const Wrapper = styled('div')(
  css({
    width: '100%',
    maxWidth: '100%',
    padding: ['1rem', '1rem 2.5rem 1.4rem'],
    borderRadius: 12,
    // backgroundColor: '#050505',
    backgroundColor: '#050505c2',
    boxShadow: '0 20px 40px 0px rgba(0, 0, 0, 0.60)'
  })
);

const Heading = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  align-items: center;
  // margin-bottom: 3rem;
  font-size: 1.5rem;
  color: #e2e2e2;
  cursor: pointer;
`;

const Details = styled.div`
  .custom-left-arrow .icon,
  .custom-right-arrow svg {
    background: rgb(255 255 255 / 20%);
    opacity: 1;
  }

  // .slick-list {
  //   margin: 0 -10px; /* compensate so track aligns properly */
  // }

  .seasons-container {
    display: flex;
    gap: 1rem;
    padding-left: 10px;
    margin-top: -1rem;
    margin-bottom: 2rem;
  }

  .tab {
    background-color: ${(props) => (props.theme === 'light' ? '#f0f0f0' : '#262929')};
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => (props.theme === 'light' ? '#000' : '#fff')};
    padding: 0.5rem 0.8rem;
    max-width: 88px;
    border-radius: 6px;
    outline: none;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: ${(props) => (props.theme === 'light' ? '#f0f0f0' : '#191b1bff')};
    }
  }

  .tab.active {
    background-color: ${(props) => (props.theme === 'light' ? '#262929' : '#d9d9d9')};
    color: ${(props) => (props.theme === 'light' ? '#fff' : '#000')};
  }

  .episode-heading {
    color: #e50019;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 2rem;
  }

  .single-episode {
    cursor: pointer;
    transition: 0.3s ease-in-out;
    display: block;
    position: relative;
    margin-right: 1rem;
    margin-bottom: 1rem;
    padding-left: 10px;
    border-radius: 8px;
    text-decoration: none;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    .img-container {
      height: 121px;
      min-width: 218px;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
      }
    }

    .episodeDetails {
      transition: all 0.1s ease-in-out 0.2s;
    }

    .episodeInfo {
      // margin-top: 1rem;
      padding: 0.5rem 0.9rem;
      transition: all 0.1s ease-in-out 0.2s;
      background: #0e0e0e;
      color: #fff;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }

    .episodeTitle {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 0.2rem;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .episodeDuration {
      font-size: 12px;
      font-weight: 500;
      display: flex;
      gap: 0.3rem;
      align-items: center;
      margin-bottom: 0.5rem;
    }
    .episodeDesc {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 0.5rem;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    // :last-child {
    //   margin-right: 0rem;
    // }
  }

  @media (max-width: 1499px) {
    .seasons-container {
      padding-left: 5px;
      margin-bottom: 1rem;
    }
    .tab {
      font-weight: 500;
    }
    .single-episode {
      padding-left: 5px;

      .img-container {
        height: 84px;
        min-width: 146px;
      }
      .episodeTitle {
        font-size: 14px;
        margin-bottom: 0;
      }
      .episodeDuration {
        margin-bottom: 0.2rem;
      }
      .episodeDesc {
        font-size: 11px;
      }
    }
  }

  @media (max-width: 1024px) {
    .single-episode {
      .img-container {
        height: 82px;
        min-width: 121px;
      }
    }
  }

  @media (max-width: 639px) {
    flex-direction: column;

    .single-episode {
      padding: 0;
      padding-left: 5px;

      .img-container {
        width: 100%;
        min-width: 100px;
        position: relative;
      }
      // .img-container::before {
      //   content: '';
      //   width: 100%;
      //   height: 100%;
      //   position: absolute;
      //   border-radius: 0.5em;
      //   background-image: linear-gradient(
      //     to bottom,
      //     rgba(5, 5, 5, 0.4),
      //     rgba(5, 5, 5, 0.46) 50%,
      //     rgba(5, 5, 5, 0.8) 100%
      //   );
      //   left: 0;
      //   bottom: -1px;
      // }
      // .episodeInfo {
      //   position: absolute;
      //   bottom: 15%;
      // }
      .episodeInfo .episodeDesc {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
`;

export default SeriesPlaylistModal;
